import * as React from 'react';
import { Button, Spinner, Tooltip } from 'reactstrap';
import { IAuthenticatedAppData } from '../../../../AuthenticatedApp/AuthenticatedApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRedo, faUnlockAlt, faUndo, faLock, faSyncAlt, faCertificate, faFileSignature, faFileContract } from '@fortawesome/free-solid-svg-icons';
import './Styles/Locations.css';
import { EventHandlerProvider } from '../../../../Services/EventHandlerService';
import { EditLocationEvent, DeleteLocationEvent, AddLocationEvent, ArvatoAddLocationPlaceholderEvent, ArvatoRenewCertEvent, ArvatoChangePasswordEvent } from './Types';
import { getJson, UserRequestHeaders } from '../../../../Services/Util';
import Endpoints from '../../../../Utils/Endpoints';
import { Auth, AuthenticationService } from '../../../../Services/AuthenticationService';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { IResources } from '../../../../Types';
import { ActionButton } from '../../Components/Exports';
import { TooltipX } from '../../../../Components';

const getColumns = (apiProvider: string, resources: IResources) => {
    if (apiProvider === "Ssr") {
        return [{
            dataField: 'Name',
            text: resources.LocationName,
            sort: true,
            style: {
                verticalAlign: 'middle'
            }
        }, {
            dataField: 'Actions',
            text: '',
            sort: false,
            style: {
                verticalAlign: 'middle'
            },
            headerStyle: {
                width: '20%'
            }

        }];
    }
    else {
        return [{
            dataField: 'Name',
            text: resources.LocationName,
            sort: true,
            style: {
                verticalAlign: 'middle'
            }
        }, {
            dataField: 'Type',
            text: resources.LocationType,
            sort: true,
            style: {
                verticalAlign: 'middle'
            }
        }, {
            dataField: 'Expiry',
            text: resources.Expires,
            sort: true,
            style: {
                verticalAlign: 'middle'
            }
        }, {
            dataField: 'Actions',
            text: '',
            sort: false,
            style: {
                verticalAlign: 'middle'
            },
            headerStyle: {
                width: '20%'
            }

        }];
    }
};

const defaultSorted = [{
    dataField: 'Name',
    order: 'asc'
}];

interface ILocationsProps {
    applicationData: IAuthenticatedAppData;
}

interface ILocationsState {
    modal: boolean;
    currentLocation: any | undefined;
    page: number;
    totalPages: number;
    locationData: any[];
    parseLocationData: boolean;
}

export class Locations extends React.Component<ILocationsProps, ILocationsState> {
    constructor(props: ILocationsProps) {
        super(props);
        this.state = {
            modal: false,
            currentLocation: undefined,
            page: 1,
            totalPages: Math.ceil(props.applicationData.locations.length / 10),
            locationData: this.addActionsToLocationData(props.applicationData.locations).map((location: any) => { location.Expiry = <Spinner size="sm" color="secondary" />; return location; }),
            parseLocationData: false
        };

        this.clientIdRef = React.createRef();
        this.clientSecretRef = React.createRef();
        this.deleteLocationRef = React.createRef();
        this.locationNameRef = React.createRef();
        this.locationNameFeedbackRef = React.createRef();
        this.clientIdFeedbackRef = React.createRef();
        this.clientSecretFeedbackRef = React.createRef();
        this.buttonRef = React.createRef<HTMLButtonElement>();
    }

    clientIdRef: React.RefObject<HTMLInputElement>;
    clientSecretRef: React.RefObject<HTMLInputElement>;
    deleteLocationRef: React.RefObject<HTMLInputElement>;
    locationNameRef: React.RefObject<HTMLInputElement>;
    locationNameFeedbackRef: React.RefObject<HTMLSpanElement>;
    clientIdFeedbackRef: React.RefObject<HTMLSpanElement>;
    clientSecretFeedbackRef: React.RefObject<HTMLSpanElement>;
    buttonRef: React.RefObject<HTMLButtonElement>;

    componentDidMount() {
        if (this.props.applicationData.apiProvider != "Ssr") {
            this.getData(this.state.locationData).then((locations: any) => {
                this.setState({ locationData: this.addActionsToLocationData(locations) })
            })
        }
    }

    componentDidUpdate() {
        if (this.state.parseLocationData) {
            if (this.props.applicationData.apiProvider != "Ssr") {
                this.getData(this.props.applicationData.locations).then((locations: any) => {
                    this.setState({
                        locationData: this.addActionsToLocationData(locations),
                        parseLocationData: false
                    })
                })
            } else {
                this.setState({
                    locationData: this.addActionsToLocationData(this.props.applicationData.locations),
                    parseLocationData: false
                });
            }
        }
    }

    addActionsToLocationData = (locationData: any): any => {
        locationData.map((location: any) => {
            var expiryCheck = false;
            if (this.props.applicationData.apiProvider !== "Ssr" && location.Expiry !== undefined && location.Expiry.length == 10) {
                var expiryDate = new Date(location.Expiry);
                var renewalThreshold = new Date();
                renewalThreshold.setDate(renewalThreshold.getDate() + 60);
                expiryCheck = expiryDate < renewalThreshold
            }
            
            location.Actions = (
                <div style={{
                    display: 'flex', justifyContent: 'space-evenly', lineHeight: '2.5', color: "transparent", minHeight: "2.4rem"
                }}>


                    {this.props.applicationData.apiProvider !== "Ssr" &&
                    <>
                                        <div>
                        <Button color={"primary"} innerRef={this.buttonRef} style={{ width: "46px", height: "38px" }} onClick={() => {
                            EventHandlerProvider.GetInstance().AddEvent(
                                ArvatoRenewCertEvent(location.Name, this.certRenewalUpdateCallback, this.props.applicationData)
                            );
                        }}>
                            <FontAwesomeIcon icon={faFileContract} style={{ fontSize: "1.5rem" }} />
                        </Button>
                        {this.buttonRef !== undefined &&
                            <TooltipX placement={"bottom"} target={this.buttonRef}>
                                {this.props.applicationData.resources.RenewCertificate}
                            </TooltipX>
                        }
                    </div>
                    <ActionButton
                            Event={ArvatoChangePasswordEvent(location.Name, this.props.applicationData)}
                            TooltipText={this.props.applicationData.resources.ChangePassword}
                            MultipleIcons={true}
                            Icons={[faLock, faSyncAlt]}
                            colour="primary"
                        >
                        </ActionButton></>

                    }

                    {this.props.applicationData.selectedLocation != location.Name &&
                        <ActionButton
                            Event={DeleteLocationEvent(location.Name, this.updateCallback, this.props.applicationData.resources)}
                            TooltipText={this.props.applicationData.resources.Delete}
                            Icons={faTrash}
                            colour="danger"
                        >
                        </ActionButton>
                    }
                </div>
            );
        });

        return locationData;
    };

    getLocationExpiry = (location:any) => {
        return getJson(`${Endpoints.GetLocationExpiry}?location=${location.Name}`, undefined, true, new UserRequestHeaders(Auth.getUser()))
            .then((response) => {
                return { ...location, Expiry: response };
            }).catch(reason =>
                console.error("Error loading locations, with reason: " + reason)
            );
    }

    getLocationExpiryAsync = async (item:any) => {
        return this.getLocationExpiry(item)
    }

    getData = async (locationData: any[]) => {
        return Promise.all(locationData.map(item => this.getLocationExpiryAsync(item)))
    }

    toggle = (location?: any) => {
        if (location != undefined) {
            this.setState({
                currentLocation: location
            });
        }

        this.setState((prevState) => {
            return {
                modal: !prevState.modal
            };
        }, () => {
            var closeButton = document.getElementsByClassName("close")[0] as HTMLElement;
            if (closeButton != null || closeButton != undefined) {
                closeButton.style.display = "none";
            }
        });
    };

    changePage = (newPage: number) => {
        this.setState({
            page: newPage
        });
    };

    updateCallback = (updateSelectedLocation: string = "") => {
        //console.log("Update Callback Locations.tsx");
        getJson(Endpoints.GetLocations, undefined, true, new UserRequestHeaders(Auth.getUser()))
            .then((response) => {
                var value = JSON.parse(response);
                this.props.applicationData.updateCallback("locations", value);

                var totalPages = Math.ceil(value.length / 10);
                var page = this.state.page <= totalPages ? this.state.page : totalPages;
                this.setState({
                    page: page,
                    totalPages: totalPages,
                    parseLocationData: true
                });
            }).catch(reason =>
                console.error("Error loading locations, with reason: " + reason)
            );

        if (updateSelectedLocation != "") {
            this.props.applicationData.updateCallback(AuthenticationService.selectedLocationKey, updateSelectedLocation);
        }
    };

    certRenewalUpdateCallback = () => {
        this.setState(
            (prevState: ILocationsState) => {
                return {
                    locationData: this.addActionsToLocationData(prevState.locationData.map(
                        (location: any) => {
                            if (location.Name === location) {
                                return { ...location };
                            }
                            return location;
                        }))
                }
            })
    }

    render() {
        return (
            <div className="my-1">
                <div className="my-2 fv-c">
                    <h2>{this.props.applicationData.resources.Locations}</h2>
                    <Button className="locations-add-btn ml-3" color="primary" onClick={() => {
                        EventHandlerProvider.GetInstance().AddEvent(
                            AddLocationEvent(this.updateCallback, this.props.applicationData)
                        );
                    }} > {this.props.applicationData.resources.AddNewLocation} </Button>
                </div>
                <BootstrapTable
                    bootstrap4
                    condensed
                    hover
                    bordered={false}
                    keyField="Name"
                    data={this.state.locationData}
                    columns={getColumns(this.props.applicationData.apiProvider, this.props.applicationData.resources)}
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory()}
                />

            </div>
        );
    }
}